import { Typography, Card, CardContent, Stack } from "@mui/material";
import "./ManagementsListCard.scss";
import { useTranslation } from "react-i18next";
import { formatDate } from "../../../utils/dateUtils/formatDate.util";
import {
  getManagementTitleText,
  getManagementSubtypeTextIcon,
} from "../../../utils/components/managements/managements.util";
import theme from "../../../muiTheme";
import { MANAGEMENTS_REGISTER_TYPE_CLAIMS } from "../../../core/constants/constants";
import { useNavigate } from "react-router-dom";
import { ManagementsDetailHeader } from "../../../core/models/managements/managements.model";

interface ManagementsListCardProps {
  backgroundColor: string;
  color: string;
  icon: string;
  label: string;
  socialReason: string;
  cups: string;
  cif: string;
  incidenceIconTitle: {
    title: string;
    icon: string;
  };
  date: string;
  idSubType: number;
  issueNumber: string;
  setManagementsDetailHeader: React.Dispatch<
    React.SetStateAction<ManagementsDetailHeader>
  >;
  recordTextType: string;
  claimTextSubType: string;
  incidenceText: string;
  isIncidenceText: boolean;
}

export const ManagementsListCard = ({
  backgroundColor,
  color,
  icon,
  label,
  socialReason,
  cups,
  cif,
  incidenceIconTitle,
  date,
  idSubType,
  issueNumber,
  setManagementsDetailHeader,
  recordTextType,
  claimTextSubType,
  incidenceText,
  isIncidenceText,
}: ManagementsListCardProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Card
      className="last-managements__card"
      sx={{
        borderRadius: "12px",
        marginBottom: "1rem",
        cursor: "pointer",
      }}
      key={issueNumber}
      onClick={() => {
        navigate(`${process.env.REACT_APP_MANAGEMENT_DETAIL}/${issueNumber}`);
        setManagementsDetailHeader({
          recordTextType,
          claimTextSubType,
          incidenceText,
          idSubType,
        });
      }}
    >
      <CardContent sx={{ "&&": { padding: "16px" } }}>
        <Stack justifyContent="space-between" direction="row">
          <Stack
            flexWrap={{ xs: "wrap", md: "nowrap" }}
            justifyContent={{ xs: "space-between", md: "flex-start" }}
            direction="row"
            gap="2rem"
            sx={{ flexBasis: "40%", flexGrow: "1" }}
          >
            <Typography
              fontSize={"32px"}
              component="p"
              color="primary.main"
              margin={{ xs: "0", md: "auto 0" }}
              style={{ width: "32px" }}
              order={{ xs: "-2", md: "0" }}
            >
              <span
                className={
                  recordTextType === MANAGEMENTS_REGISTER_TYPE_CLAIMS
                    ? "t-icon-warning"
                    : isIncidenceText
                      ? incidenceIconTitle.icon
                      : getManagementSubtypeTextIcon(idSubType).icon
                }
              />
            </Typography>
            <Stack
              direction={{ xs: "column", md: "row" }}
              justifyContent={"flex-start"}
              width="100%"
              columnGap={{ xs: "0.5rem", md: "2rem" }}
              rowGap={"2rem"}
            >
              <Stack
                direction="column"
                // sx={{ flexBasis: { md: "300px" } }}
                maxWidth={{ xs: "300px", sm: "none" }}
                flexGrow={{ xs: 1, md: 0.1 }}
                className="last-managements__title-date"
              >
                <Typography component="h6" variant="body2">
                  {t(
                    `Gestiones.${
                      isIncidenceText
                        ? incidenceIconTitle.title
                        : getManagementTitleText(
                            recordTextType,
                            claimTextSubType,
                            idSubType,
                          )
                    }`,
                  )}
                </Typography>

                <Typography lineHeight={"24px"} variant="caption">
                  {`${t("Gestiones.Solicitado el")} ${formatDate(
                    new Date(date),
                  )}`}
                </Typography>
              </Stack>
              <Stack
                flexDirection={"row"}
                flexWrap={"wrap"}
                columnGap={"1rem"}
                rowGap={"10px"}
              >
                <Stack className="last-managements__extra-info">
                  <Typography fontWeight={400} fontSize={"14px"}>
                    {socialReason}
                  </Typography>
                </Stack>
                <Stack
                  flexDirection={"row"}
                  flexWrap={"wrap"}
                  columnGap={"1rem"}
                  rowGap={"10px"}
                >
                  <Stack className="last-managements__extra-info">
                    <Typography
                      fontSize={"14px"}
                      component="h6"
                      variant="body2"
                      fontWeight={400}
                    >
                      {cif}
                    </Typography>
                  </Stack>
                  <Stack className="last-managements__extra-info">
                    <Typography fontSize={"14px"} fontWeight={400}>
                      {cups}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
            <Typography
              variant="body2"
              component="span"
              width={"fit-content"}
              sx={{
                backgroundColor,
                color,
                textWrap: "nowrap",
              }}
              className="state-chip"
              height={"fit-content"}
              alignSelf={{ xs: "start", md: "center" }}
              marginRight={"20px"}
              order={{ xs: "-1", md: "0" }}
            >
              <span aria-hidden="true" className={icon} />
              {t(label)}
            </Typography>
          </Stack>
          <Typography
            component="h5"
            variant="h5"
            color={theme.palette.primary.main}
            margin="auto 0"
          >
            <span
              className="t-icon-long-arrow-right"
              style={{ alignSelf: "flex-end" }}
            />
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
};
